import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import {
  checkValidPostcodeAction,
  getAssignNotificationMessageAction,
  getLeadNotificationMessageAction,
  getNotificationMessageAction,
  getUploadKeyAction,
  getWelcomeClosedAction,
  putUploadFileAction,
  setAssignNotificationMessageAction,
  setCheckValidPostcodeAction,
  setLeadNotificationMessageAction,
  setLoaderAction,
  setNotificationAction,
  setNotificationMessageAction,
  setUploadFileAction,
  setWelcomeClosedAction,
} from "../reducers/mmymSlice";
import store from "../store";
import { updateUserProfileAction } from "../reducers/userSlice";
import { updateTCDocumentAction } from "../reducers/documentSlice";
import { setNewClientLocal } from "../reducers/adminClientsSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getUploadKeySaga(payload: any): any {
  console.log("payload-", payload);
  const { fileName, fileType, body, page = "", keepPublic =false } = payload?.payload;
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    let url =''
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const user = JSON.parse(storedUser);
      if(user?.user?.roles[0]?.includes("CUSTOMER")){
        url = `customers/upload?fileName=${fileName}&fileType=${fileType}&keepPublic=${keepPublic}`;
      }else {
        url = `client/upload?fileName=${fileName}&fileType=${fileType}&keepPublic=${keepPublic}`;
      }
    }
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "get",
      url
    );
    console.log("uploadFileResponse-", apiResponse);
    if (apiResponse?.success === true) {
      // apiResponse && handleSuccess(apiResponse);
      yield put(
        putUploadFileAction({
          publicUrl: apiResponse?.data?.url,
          url: apiResponse?.data?.uploadURL,
          body: body,
          fileType,
          fileKey: apiResponse?.data?.key,
          page,
        })
      );
      // yield put(setChangePasswordAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    // yield put(setChangePasswordAction(false));
  }
  // yield put(setLoaderAction(false))
}

function* putUploadFileSaga(payload: any): any {
  console.log("payload-upload-", payload);
  const { url, body, fileType, fileKey, page, publicUrl,templatesName } = payload?.payload;
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload: body },
      "put",
      url,
      fileType
    );
    const imageUploadKey: any = store.getState()?.mmym?.imageUploadKey;
    yield put(
      setUploadFileAction({
        url: imageUploadKey?.url,
        key: fileKey,
        publicUrl:publicUrl || ""
      })
    );
    if (page === "profile") {
      const userProfile: any = store.getState()?.user?.userProfile;
      yield put(
        updateUserProfileAction({
          status: userProfile?.status,
          userEmailSignature: userProfile?.user_email_signature || "",
          photo: fileKey,
        })
      );
      yield put(
        setUploadFileAction({
          url: "",
          key: "",
        })
      );
      yield put(setLoaderAction(false));
    }else if(page === 'client'){
      const newClientLocal: any = store.getState()?.adminClients?.newClientLocal;
      yield put(
          setNewClientLocal({
            // ...newClientLocal,
            companyProfile: {
              ...newClientLocal?.companyProfile,
              logo: fileKey
            }
          })
        );
        yield put(setLoaderAction(false))
  }else if(page ==='docs'){
      yield put(updateTCDocumentAction({name:'terms_conditions', s3key: fileKey}));
    }else if(page === 'templates'){
      yield put(updateTCDocumentAction({name:templatesName, s3key: fileKey, ...(templatesName?.toLowerCase().includes("storage-contract")
      ? { isPrivate: true }
      : {}),}));
    }
    yield put(setLoaderAction(false));
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    // yield put(setChangePasswordAction(false));
    yield put(setLoaderAction(false));
  }
}

function* checkValidPostcodeSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
     const postCode = action.payload;
    let url =''
    const storedUser = localStorage.getItem("user");
     if (storedUser) {
      const user = JSON.parse(storedUser);
      if(user?.user?.roles[0]?.includes("CUSTOMER")){
        url = `customers/exists?postCode=${postCode}`;
      }else {
        url = `client/exists?postCode=${postCode}`;
      }
    }
    // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      url
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      // yield put(setDeleteTelnetAction(apiResponse?.message));
      yield put(setCheckValidPostcodeAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setCheckValidPostcodeAction(false));
  }
  yield put(setLoaderAction(false));
}

function* getNotificationMessageSaga(): any {
  yield put(setLoaderAction(true));
  console.log("plans-try");
  try {
    const res = yield call<any>(callAPI, {}, "get", `client/notifications`);
    console.log("plans-", res);
    if (res?.data) {
      yield put(setNotificationMessageAction(res?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getAssignNotificationMessageSaga(action:any): any {
  yield put(setLoaderAction(true));
  try {    
    const {userId}= action?.payload || {};
    const res = yield call<any>(callAPI, {}, "get", `client/tasks?assigned_to=${userId}`);
    if (res?.data) {
      yield put(setAssignNotificationMessageAction(res?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* getWelcomeClosedSaga(): any {
  yield put(setLoaderAction(true));
  try {
    const apiResponse = yield call<any>(callAPI, {}, "get", `client/close-welcome`);
    console.log("plans-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setWelcomeClosedAction(true));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response, [401]);
  }
  yield put(setLoaderAction(false));
}

// get lead notification message
function* getLeadNotificationMessageSaga(): any {
  yield put(setLoaderAction(true));
  try {    
    const res = yield call<any>(callAPI, {}, "get", `leads/notifications`);
    if (res?.data) {
      yield put(setLeadNotificationMessageAction(res?.data));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}
    

export function* watchMMYM() {
  yield takeLatest<any>(getUploadKeyAction, getUploadKeySaga);
  yield takeLatest<any>(putUploadFileAction, putUploadFileSaga);
  yield takeLatest<any>(checkValidPostcodeAction, checkValidPostcodeSaga);
  yield takeLatest<any>(
    getNotificationMessageAction,
    getNotificationMessageSaga
  );
  yield takeLatest<any>(getWelcomeClosedAction, getWelcomeClosedSaga);
  yield takeLatest<any>(getAssignNotificationMessageAction, getAssignNotificationMessageSaga);
  yield takeLatest<any>(getLeadNotificationMessageAction, getLeadNotificationMessageSaga);
}
